@if (data$ | async; as component) {
  <div class="floating-container alignment-{{component.contentAlignment}}"
    [style]="'background-color :'+ component.background">
    <div class="text-content">
      @switch (component.titleTag) {
        @case ('H1') {
          <h1
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h1>
        }
        @case ('H2') {
          <h2
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h2>
        }
        @default {
          <div
            class="h2-component title"
            [style.color]="component.titleColor"
            [style.font-size]="component.titleSize + 'px'"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </div>
        }
      }
      <div
        class="text"
        [style.color]="component.textColor"
        [style.font-size]="component.textSize + 'px'"
        [style.font-weight]="component.textBold === 'true' ? 'bold' : '400'"
        >
      {{component.text}}</div>
      @if (component.textButton && component.urlButton) {
        <div class="button">
          <a
            [routerLink]="component.urlButton"
            class="btn btn-outline-primary btn-sm"
            [style.color]="component.textColor"
            >
            {{ component.textButton }}
          </a>
        </div>
      }
    </div>
    <div class="image">
      <a [routerLink]="component.urlButton">
        <cx-media [container]="component.image"></cx-media>
      </a>
    </div>
  </div>
}